export default function TransferEleviPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <p className="text-gray-700">transfer elevi</p>
      </main>
    </div>
  );
}
